import { object, string, boolean, SchemaOf } from 'yup'
import { Enrollment } from '@clear-denver/tpc-openapi-typescript'
import { lastNameValidation } from '@utils/validation'

export const nameLabels: Record<keyof Enrollment.NameObject, string> = {
  firstName: 'First Name',
  lastName: 'Last Name',
  middleName: 'Middle Name',
  noMiddleName: 'No Middle Name',
  suffix: 'Suffix (Optional)',
}

const suffix = string()
  .optional()
  .transform((value) => {
    if (value === '') {
      return undefined
    }
    return value
  })

export const nameStringSchema = string()
  .test(
    'special-characters',
    'Cannot include special characters. ',
    (value?: string) => !/[^a-zA-Z-\s']/.test(value || '')
  )
  .test(
    'one-letter',
    'Must include at least one letter.',
    (value?: string) => value !== ''
  )
  .test(
    'start-hyphen',
    'Cannot start with a hyphen.',
    (value = '') => value[0] !== '-'
  )
  .test(
    'start-apostrophe',
    'Cannot start with an apostrophe.',
    (value = '') => value[0] !== "'"
  )
  .test(
    'start-space',
    'Cannot start with a space.',
    (value = '') => value[0] !== ' '
  )
  .test(
    'end-hyphen',
    'Cannot end with a hyphen.',
    (value = '') => value[value.length - 1] !== '-'
  )
  .test(
    'end-apostrophe',
    'Cannot end with an apostrophe.',
    (value = '') => value[value.length - 1] !== "'"
  )
  .test(
    'end-space',
    'Cannot end with a space.',
    (value = '') => value[value.length - 1] !== ' '
  )
  .test(
    'consecutive-chars',
    'Cannot include consecutive hyphens, apostrophes, or spaces.',
    (value = '') =>
      !/\s\s+/g.test(value) && !/''+/g.test(value) && !/--+/g.test(value)
  )

const lastNameSchema = nameStringSchema.test(
  'use-suffix-field',
  'Use suffix field',
  (value = '') => lastNameValidation(value)
)

const nameSchema: SchemaOf<Enrollment.NameObject> = object().shape({
  firstName: nameStringSchema.required().label(nameLabels.firstName),
  lastName: lastNameSchema.required().label(nameLabels.lastName),
  middleName: string()
    .when('noMiddleName', {
      is: false,
      then: nameStringSchema.required(),
    })
    .label(nameLabels.middleName),
  noMiddleName: boolean().required().label(nameLabels.noMiddleName),
  suffix: suffix.label(nameLabels.suffix),
})

export default nameSchema
